<script lang="ts">
	import { getContext, onMount } from "svelte";

	import { mode, settings } from "../../stores";
	import { modeData } from "../../utils";
	import type { Toaster } from "../widgets";
	import Setting from "./Setting.svelte";

	export let state: GameState;

	const toaster = getContext<Toaster>("toaster");

	let root: HTMLElement;
	onMount(() => {
		root = document.documentElement;
	});
	$: {
		if (root) {
			$settings.dark ? root.classList.remove("light") : root.classList.add("light");
			$settings.colorblind
				? root.classList.add("colorblind")
				: root.classList.remove("colorblind");
			localStorage.setItem("settings", JSON.stringify($settings));
		}
	}
</script>

<!-- not currently supported, see https://github.com/sveltejs/svelte/issues/3105 -->
<!-- <svelte:body class:light={!$settings.dark} class:colorblind={$settings.colorblind} /> -->
<div class="outer">
	<div class="settings-top">
		<h3>settings</h3>
		<div
			on:click={() => {
				if (!state.validHard) {
					toaster.pop("El juego ya ha infringido el modo difícil");
				}
			}}
		>
			<Setting type="switch" bind:value={$settings.hard[$mode]} disabled={!state.validHard}>
				<span slot="title">Modo Difícil</span>
				<span slot="desc">Cualquier pista revelada debe ser utilizada en los siguientes intentos</span>
			</Setting>
		</div>
		<Setting type="switch" bind:value={$settings.dark}>
			<span slot="title">Modo Oscuro</span>
		</Setting>
		<Setting type="switch" bind:value={$settings.colorblind}>
			<span slot="title">Modo para Daltónicos</span>
			<span slot="desc">Colores con Alto Contraste</span>
		</Setting>
		<Setting type="dropdown" bind:value={$mode} options={modeData.modes.map((e) => e.name)}>
			<span slot="title">Modo de Juego</span>
			<span slot="desc">El modo de juego determina cada cuanto debe actualizarse la palabra</span>
		</Setting>
		<div class="links">
			<a href="https://twitter.com/ElSamuGuerra" target="_blank">Sígueme en Twitter</a>
			<a href="mailto:contacto@samuguerra.com" target="_blank">Reporta algún error</a>
		</div>
	</div>
</div>

<style>
	.outer {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	.links {
		font-size: var(--fs-medium);
		border-bottom: 1px solid var(--border-primary);
		color: var(--fg-secondary);
		display: flex;
		justify-content: space-between;
	}
	:global(.settings-top > div) {
		padding: 16px 0;
		border-bottom: 1px solid var(--border-primary);
	}
</style>
